<template>
  <form ref="form" action="./" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <input type="hidden" name="test_type" :value="abtest.abtest_type" />
    <div class="l-page l-page--abtest-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <h2 class="c-title__text c-title__text--blue u-fs34">配信メッセージの新規作成</h2>
            <div class="c-text">【コンテンツ比較のA/Bテスト】</div>
          </div>
          <div class="c-progress c-progress--abtest-message">
            <ul class="c-progress-list">
              <li class="c-progress-list__item">メッセージの作成<br />Aパターン</li>
              <li class="c-progress-list__item">メッセージの作成<br />Bパターン</li>
              <!-- <li class="c-progress-list__item">配信条件の<br>設定</li> -->
              <li class="c-progress-list__item is-current">配信内容の<br />確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>
        <div class="l-main-content">
          <abtest-info :abtest="abtest" />
        </div>
        <div class="l-main-content">
          <div class="p-abtest-edit-preview">
            <div class="p-abtest-edit-preview-list">
              <div class="p-abtest-edit-preview-list__item">
                <h4 class="c-title c-title--pattern" data-text="A">
                  <div class="c-title__text u-fs28">Aパターンの配信内容</div>
                  <div class="c-text">
                    <a :href="linkData.patternAUrl" style="cursor: pointer; font-size: 16px; margin-left: 30px;">編集する</a>
                  </div>
                </h4>
                <div class="p-message-preview">
                  <div class="c-title c-title--left u-text-white-1">
                    <div class="c-title__text u-fs--l ">プレビュー</div>
                    <div class="c-text u-fs10">実際の配信メッセージと表示が異なることがあります</div>
                  </div>
                  <!--
                                    <div class="c-tab">
                                        <ul class="c-tab-list">
                                            <li class="c-tab-list__item is-active" data-type="desktop">PCでの配信例</li>
                                            <li class="c-tab-list__item" data-type="mobile">スマホでの配信例</li>
                                        </ul>
                                    </div>
                                    -->
                  <div class="p-message-preview-list">
                    <message-preview
                      :title="messageA.message_title"
                      :text="messageA.message_text"
                      :url="messageA.click_url"
                      :icon-url="messageA.image_url"
                      :large-image-url="messageA.large_image_url"
                      :has-button-a="messageA.action_button_text_a != null"
                      :has-button-b="messageA.action_button_text_b != null"
                      :action-button-text-a="messageA.action_button_text_a"
                      :action-button-text-b="messageA.action_button_text_b"
                    />
                  </div>
                </div>
              </div>
              <div class="p-abtest-edit-preview-list__item">
                <h4 class="c-title c-title--pattern" data-text="B">
                  <div class="c-title__text u-fs28">Bパターンの配信内容</div>
                  <div class="c-text">
                    <a :href="linkData.patternBUrl" style="cursor: pointer; font-size: 16px; margin-left: 30px;">編集する</a>
                  </div>
                </h4>
                <div class="p-message-preview">
                  <div class="c-title c-title--left u-text-white-1">
                    <div class="c-title__text u-fs--l ">プレビュー</div>
                    <div class="c-text u-fs10">実際の配信メッセージと表示が異なることがあります</div>
                  </div>
                  <!--
                                    <div class="c-tab">
                                        <ul class="c-tab-list">
                                            <li class="c-tab-list__item is-active" data-type="desktop">PCでの配信例</li>
                                            <li class="c-tab-list__item" data-type="mobile">スマホでの配信例</li>
                                        </ul>
                                    </div>
                                    -->
                  <div class="p-message-preview-list">
                    <message-preview
                      :title="messageB.message_title"
                      :text="messageB.message_text"
                      :url="messageB.click_url"
                      :icon-url="messageB.image_url"
                      :large-image-url="messageB.large_image_url"
                      :has-button-a="messageB.action_button_text_a != null"
                      :has-button-b="messageB.action_button_text_b != null"
                      :action-button-text-a="messageB.action_button_text_a"
                      :action-button-text-b="messageB.action_button_text_b"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-content">
          <message-action :message="messageA" />
        </div>
        <!--
                <div class="l-main-content">
                    <div class="p-message-edit-confirm p-message-edit-confirm--details">
                        <div class="c-title">
                            <div class="c-title__text u-fs24">配信条件</div>
                        </div>
                        <div class="p-message-edit-confirm-list">
                            <div class="p-message-edit-confirm-list__item">
                                <div class="p-message-edit-confirm__title">配信条件</div>
                                <div class="p-message-edit-confirm__text">セグメント配信</div>
                            </div>
                            <div class="p-message-edit-confirm-list__item">
                                <div class="p-message-edit-confirm__title">セグメント条件</div>
                                <ul class="p-message-edit-confirm-segment-list">
                                    <li class="p-message-edit-confirm-segment-list__item">選択：AND 条件</li>
                                    <li class="p-message-edit-confirm-segment-list__item">
                                        ページ：指定したページ(URL)に訪問しているユーザに対して配信します。</li>
                                    <li class="p-message-edit-confirm-segment-list__item">
                                        https://www.hogehogehoge.jp/aaaaa/aaaaaaa</li>
                                    <li class="p-message-edit-confirm-segment-list__item">
                                        https://www.hogehogehoge.jp/aaaaa/aaaaaaa</li>
                                    <li class="p-message-edit-confirm-segment-list__item">
                                        https://www.hogehogehoge.jp/aaaaa/aaaaaaa</li>
                                </ul>
                            </div>
                            <div class="p-message-edit-confirm-list__item">
                                <div class="p-message-edit-confirm__title">セグメント条件（より高度）</div>
                                <ul
                                    class="p-message-edit-confirm-segment-list p-message-edit-confirm-segment-list--bullet">
                                    <li class="p-message-edit-confirm-segment-list__item">カスタムの説明ほげほげほげほげ</li>
                                    <li class="p-message-edit-confirm-segment-list__item">カスタムの説明ほげほげほげほげ 条件</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                -->
      </main>
    </div>
    <div class="p-message-predict p-message-predict--no-number">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onQuitClick"
            >
              <p class="c-btn__text">作成をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              :class="{ 'is-loading': isLoadingSaveBtn }"
              :disabled="isLoadingSaveBtn"
              type="button"
              name="save"
              value="save"
              @click="onSaveClick"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingNextBtn }"
            :disabled="isLoadingNextBtn"
            type="button"
            name="next"
            value="next"
            @click="onNextClick($event)"
          >
            <p class="c-btn__text">配信をセットする</p>
          </button>
        </div>
      </div>
    </div>

    <!-- モーダル: 配信設定・配信停止完了メッセージ表示 -->
    <control-modal
      ref="refCompleteModal"
      classes="c-modal--result"
      :body="completeMessage"
      cancel-button-label="A/Bテスト一覧へ"
      :is-active=isCompleteMessage
      :on-close-click="onCloseControlModal"
      :on-cancel-click="onCancelControlModal"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </form>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    csrfToken: String,
    breadcrumbData: Array,
    abtest: Object,
    abtestTypeValues: Object,
    linkData: Object,
  },
  data() {
    return {
      completeMessage: '',
      errorMessage: '',
      isCompleteMessage: false,
      isError: false,
      isLoadingNextBtn: false,
      isLoadingSaveBtn: false,
    }
  },
  computed: {
    messageA: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 0) {
        message = this.abtest.abtest_messages[0].message;
      }
      return message;
    },
    messageB: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 1) {
        message = this.abtest.abtest_messages[1].message;
      }
      return message;
    },
  },
  mounted: function () {
    import('../../funcs/pages/abtest-message-add-condition-confirm').then(module => {
      module.AbtestMessageAddConditionConfirm();
    });
    import('../../funcs/components/select').then(module => {
      module.Select();
    });
  },
  methods: {
    onNextClick: function () {
      // 設定用パラメタ作成
      const params = {
        abtest_id: this.abtest.abtest_id,
      };

      // ローディング表示設定
      this.isLoadingNextBtn = true;

      axios.post('/api/abtest/set', params)
        .then(res => {
          if (this.handleResponse(res)) {
            //location.href = this.conditionInfo.listUrl;
            this.isCompleteMessage = true;
            this.completeMessage = 'プッシュ通知の配信設定が完了しました。';
          } else {
            this.isError = true;
            this.errorMessage = 'プッシュ通知の配信設定に失敗しました';
          }
          setTimeout(() => { this.isLoadingNextBtn = false; }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'プッシュ通知の配信設定に失敗しました';
          setTimeout(() => { this.isLoadingNextBtn = false; }, 300);
        });
    },
    onSaveClick: function() {
      this.isLoadingSaveBtn = true;
      location.href = this.linkData.listUrl;
    },
    onQuitClick: function() {
      location.href = this.linkData.listUrl;
    },

    // -----------------------------------------------------------------------------------------------------
    // あとでUI調整と合わせて調整をします
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // クリック: 完了モーダルを閉じる処理
    onCloseControlModal() {
      this.isCompleteMessage = false;
    },
    // クリック: 完了モーダルを閉じる処理
    onCancelControlModal() {
      this.isCompleteMessage = false;
      location.href = this.linkData.distributeUrl;
    },
  }
}
</script>
